export default __webpack_public_path__ + "static/media/magic bikkin1i.266cb6df.png";